import axios from "axios";
import { retrieveData } from "../LocalConnection/LocalConnection";
const appauth_key = "barlays@2029";
let APL_LINK = "http://192.168.1.4:8000/";
// APL_LINK = "http://192.168.164.239:8000/"
APL_LINK = 'https://metro.triosoft.ai/';
let local_server_link_react = APL_LINK + "api/admin_link/";

// API functions

const get_all_stations = local_server_link_react + "get_all_stations";
const save_update_line = local_server_link_react + "save_update_line";

const save_update_station = local_server_link_react + "save_update_station";
const get_all_cities = local_server_link_react + "get_all_cities";
const get_all_lines = local_server_link_react + "get_all_lines";
const get_line_by_id = local_server_link_react + "get_line_by_id";
const save_update_route = local_server_link_react + "save_update_route";
const get_all_routes_by_line =
  local_server_link_react + "get_all_routes_by_line";
const get_route_by_primary_id =
  local_server_link_react + "get_route_by_primary_id";
const insert_fare_rule = local_server_link_react + "insert_fare_rule";
const get_fare_rules_by_city =
  local_server_link_react + "get_fare_rules_by_city";
const get_workshop_enquiry_report =
  local_server_link_react + "get_workshop_enquiry_report";
const get_station_by_id = local_server_link_react + "get_station_by_id";
const add_fare_rule_endpoint =
  local_server_link_react + "add_fare_rule_endpoint";
const login_to_superadmin = local_server_link_react + "login_to_superadmin";

const delete_line = local_server_link_react + "delete_line";
const delete_route = local_server_link_react + "delete_route";
const save_update_adminstaff =
  local_server_link_react + "save_update_adminstaff";
const get_all_adminstaff = local_server_link_react + "get_all_adminstaff";
const delete_adminstaff = local_server_link_react + "delete_adminstaff";
const save_update_adminsilderlink = local_server_link_react + "save_update_adminsilderlink";
const get_all_adminsilderlink = local_server_link_react + "get_all_adminsilderlink";
const delete_adminsilderlink = local_server_link_react + "delete_adminsilderlink";
const delete_station = local_server_link_react + "delete_station";

const retrievedAdminId = retrieveData("admin_id");

const server_post_data = async (url_for, form_data) => {
  // const headers = {
  //   "Content-Type": "application/json",
  // };

  if (form_data === null) {
    form_data = new FormData();
  }
  form_data.append("admin_id", retrievedAdminId);
  form_data.append("appauth_key", appauth_key);
  if (form_data.get("data_call") !== null) {
    form_data.append("call_id", retrievedAdminId);
  }
  return axios.post(url_for, form_data);
};

export {
  APL_LINK,
  appauth_key,
  server_post_data,
  get_all_stations,
  get_workshop_enquiry_report,
  save_update_station,
  get_all_cities,
  get_all_lines,
  save_update_line,
  get_line_by_id,
  save_update_route,
  get_all_routes_by_line,
  get_route_by_primary_id,
  insert_fare_rule,
  get_fare_rules_by_city,
  get_station_by_id,
  delete_line,
  delete_route,
  add_fare_rule_endpoint,
  login_to_superadmin,
  save_update_adminstaff,
  get_all_adminstaff,
  delete_adminstaff,
  save_update_adminsilderlink,
  get_all_adminsilderlink,
  delete_adminsilderlink,
  delete_station
};
